import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import parseHtml, { domToReact } from 'html-react-parser';
import React, { FC } from 'react';
import SeparatorVerticalIcon from './assets/separatorVertical.inline.svg';
import { HTMLReactParserOptions } from 'html-react-parser';
import { isHTMLParserElement } from '@components/Post/Content';

type Props = StyleProps & TestIdProps & PostPartnerWidgetData;

export interface PostPartnerWidgetData {
  logo?: string;
  sublogo?: string;
  shortDescription?: string;
  title?: string;
  description?: string;
  btn?: {
    label: string;
    url: string;
  };
}

export const PostPartnerWidget: FC<Props> = ({
  testId,
  className,
  style,
  title,
  logo,
  sublogo,
  shortDescription,
  btn,
  description,
}) => {
  const parseOpt: HTMLReactParserOptions = {
    replace: domNode => {
      if (isHTMLParserElement(domNode) && domNode.name === 'p') {
        return (
          <p className={mc('mt-4', 'font-raleway leading-normal font-medium text-ocean-blue')}>{domToReact(domNode.children)}</p>
        );
      }
    },
  };
  return (
    <div
      data-testid={testId}
      className={mc(
        'px-4 py-4',
        'flex flex-col-reverse lg:items-stretch lg:flex-row',
        'rounded-3xl',
        'bg-seafoam border-neutral-gray',
        className,
      )}
      style={style}
    >
      {/* Logo */}
      <a
        className={mc(
          'block',
          'w-full lg:w-80 lg:basis-80 lg:grow-0 lg:shrink-0',
          'p-4 mt-4 lg:mt-0',
          'flex flex-col items-center justify-center',
          'rounded-3xl',
          'bg-white',
        )}
        target="__blank"
        href={btn?.url || '#'}
      >
        {!!logo && <img className="max-w-[150px]" src={logo} />}
        {!!shortDescription && (
          <span
            className={mc(
              'block',
              'mt-4',
              'max-w-[180px]',
              'font-raleway leading-normal text-center font-semibold text-ocean-blue',
            )}
          >
            {shortDescription}
          </span>
        )}
        {!!sublogo && <img className={mc('mt-4', 'max-w-[120px]')} src={sublogo} />}
        {!!btn && (
          <span className={mc('mt-4', 'block', 'flex flex-row justify-center')}>
            <span
              className={mc(
                'block',
                'px-4 py-2',
                'min-w-[72px]',
                'rounded-full',
                'bg-ocean-blue',
                'text-white text-center text-sm font-raleway leading-normal font-semibold',
              )}
            >
              {btn.label}
            </span>
          </span>
        )}
      </a>
      {/* Logo End */}
      {/* Separator */}
      <div className={mc('hidden lg:flex', 'lg:px-6 pt-6 lg:pt-0', 'flex-row items-center')}>
        <SeparatorVerticalIcon />
      </div>
      {/* Separator End */}
      {/* Info */}
      <div className={mc('w-full', 'flex flex-col lg:justify-center')}>
        {!!title && (
          <h6
            className={mc('m-0 p-0', 'text-xl font-raleway leading-normal font-bold text-ocean-blue', 'text-center lg:text-left')}
          >
            {title}
          </h6>
        )}
        <div>{!!description && parseHtml(description, parseOpt)}</div>
      </div>
      {/* Info End */}
    </div>
  );
};

export type PostPartnerWidgetProps = Props;
export default PostPartnerWidget;
